var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.22 14.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.93,10.36c.2-.22.36-.44.56-.63a3.06,3.06,0,0,1,2.22-.88A5,5,0,0,1,17.1,9a2.74,2.74,0,0,1,1.94,2,9.1,9.1,0,0,1,.26,2.33c0,1.66,0,3.31,0,5,0,.16,0,.2-.19.2H16.54c-.15,0-.19,0-.19-.19,0-1.58,0-3.16,0-4.73a4.7,4.7,0,0,0-.14-1.18,1.32,1.32,0,0,0-1.45-1A1.59,1.59,0,0,0,13.1,13a6,6,0,0,0,0,.74c0,1.53,0,3.07,0,4.6,0,.15,0,.2-.2.2H10.28c-.14,0-.18,0-.18-.18,0-3,0-6.07,0-9.11,0-.15.05-.19.19-.19h2.46c.15,0,.18.05.18.19C12.92,9.64,12.93,10,12.93,10.36Z",
    transform: "translate(-5.07 -4.37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.25,13.83v4.51c0,.17,0,.22-.21.22H5.48c-.14,0-.18,0-.18-.18V9.25c0-.12,0-.17.17-.17H8.06c.17,0,.19.07.19.21Z",
    transform: "translate(-5.07 -4.37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.48,6.07a1.7,1.7,0,0,1-1.7,1.71,1.71,1.71,0,1,1,0-3.41A1.7,1.7,0,0,1,8.48,6.07Z",
    transform: "translate(-5.07 -4.37)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcL);
export default __webpack_public_path__ + "static/media/ic_l.4da9e0ff7bbf461d7559313caaca7623.svg";
export { ForwardRef as ReactComponent };